import { useCallback } from 'react';

import type { CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageLazyQuery,
  useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageLazyQuery,
} from '../graphql/__generated__';

export function useSalesCoverage_UnderwriterEmployeeInvestorCoverage(tenantId?: string) {
  const [loadRowsAsCustomer] =
    useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageLazyQuery();
  const [loadRowsAsAdmin] =
    useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageLazyQuery();

  return useCallback(
    async (
      variables: CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
    ) => {
      if (tenantId) {
        const response = await loadRowsAsAdmin({
          variables: {
            tenantId,
            ...variables,
          },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            underwriterEmployees: {
              ...response.data?.adminUnderwriterEmployees,
            },
          },
        };
      } else {
        return await loadRowsAsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [loadRowsAsAdmin, loadRowsAsCustomer, tenantId]
  );
}
